import { Button, Checkbox, Empty, Input } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { uniq } from 'lodash';
import React, { useRef, useState } from 'react';

/**
 * Like default filter but with search feature
 * @param options
 * @returns
 */
const TableFilterCheckbox = (options: {
  options: Array<{ text: string; value: CheckboxValueType }>;
  searchPlaceholder?: string;
  hideSearch?: boolean;
}) => {
  const [selected, setSelected] = useState<{
    [keyword: string]: CheckboxValueType[];
  }>({ 'empty-string': [] });
  const [filter, setFilter] = useState('');
  const trimmedFilter = filter.trim().toLowerCase();
  const filteredOptions = options.options.filter(obj => {
    return obj.text.toLowerCase().includes(trimmedFilter);
  });
  const searchTimer = useRef(null);

  return ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
    // close,
  }) => {
    return (
      <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
        {!options.hideSearch && (
          <Input.Search
            placeholder={options.searchPlaceholder || 'Search'}
            onChange={e => {
              e.persist();
              if (searchTimer.current) {
                clearTimeout(searchTimer.current);
              }

              searchTimer.current = setTimeout(() => {
                setFilter(e.target?.value);
              }, 500);
            }}
            style={{ marginBottom: 8, display: 'block' }}
            enterButton
            allowClear
          />
        )}
        {!filteredOptions?.length ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <div style={{ height: 400, overflow: 'auto' }}>
            <Checkbox.Group
              value={selectedKeys}
              onChange={values => {
                const allSelected = [
                  ...Object.keys(selected).reduce((allId, kKeyword) => {
                    const keyword = kKeyword === '' ? 'empty-string' : kKeyword;
                    if (keyword === filter) {
                      return allId;
                    }
                    return [...allId, ...selected[keyword]];
                  }, []),
                  ...values,
                ];

                setSelectedKeys(uniq(allSelected));
                setSelected(sel => ({
                  ...sel,
                  [filter === '' ? 'empty-string' : filter]: values,
                }));
              }}
            >
              <ul style={{ padding: 0, margin: '0 0 15px', listStyle: 'none' }}>
                {filteredOptions.map((item, itemIdx) => (
                  <li key={`${item.value}-${itemIdx}`}>
                    <Checkbox value={item.value}>{item.text}</Checkbox>
                  </li>
                ))}
              </ul>
            </Checkbox.Group>
          </div>
        )}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Button
            type="link"
            onClick={() => {
              setSelected({ 'empty-string': [] });
              clearFilters();
            }}
          >
            Reset
          </Button>
          <Button type="primary" onClick={() => confirm()}>
            Apply
          </Button>
        </div>
      </div>
    );
  };
};

export default TableFilterCheckbox;
